"use client";

import styled from "styled-components";
import { hideVisually } from "polished";
var VisuallyHidden = styled.span.withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-8buqks-0"
})(["", ";"], hideVisually);
export default VisuallyHidden;